import React from "react";
import { ActionContainer, MainContainer } from "./styles";
import { FaBell, FaCog } from "react-icons/fa";
import ThemeColors from "../../../../themes/colors";
import CompanySelection from "./components/CompanySelection";
import UserPopover from "../../../../components/UserPopover";

const TopBar: React.FC = (): JSX.Element => {
  return (
    <MainContainer>
      <CompanySelection />
      <ActionContainer>
        <FaBell color={ThemeColors.Bg300} style={{ cursor: "pointer" }} />
        <FaCog color={ThemeColors.Bg300} style={{ cursor: "pointer" }} />
        <UserPopover />
      </ActionContainer>
    </MainContainer>
  );
};

export default TopBar;
